module.exports = __webpack_public_path__ + "static/media/Combined.25e4f353.svg";